<script setup lang="ts">
const items = [
  {
    title: 'Dana COD Tertahan Lama',
    description: 'Paket sudah terkirim, tapi modal belum bisa diputar kembali.',
    icon: 'material-symbols:credit-card-off'
  },
  {
    title: 'Produksi & Stok Tertunda',
    description: 'Cashflow yang lambat menghambat perputaran persediaan.',
    icon: 'material-symbols:open-in-new-off'
  },
  {
    title: 'Kesempatan Ekspansi Hilang',
    description: 'Modal kerja tertahan berarti kehilangan peluang tumbuh.',
    icon: 'material-symbols:do-not-disturb-off-outline'
  },
  {
    title: 'Operasional Terhambat',
    description:
      'Beban pembayaran vendor dan biaya rutin jadi tidak fleksibel.',
    icon: 'material-symbols:timer-off-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Saat Cashflow Terlambat, Pertumbuhan Bisnis Ikut Tertahan"
    description="Bagi pembisnis, proses pengiriman membutuhkan waktu sedangkan biaya harus tepat waktu, pencairan dana COD yang lama bisa berdampak langsung pada arus kas operasional."
    hero-image="/images/cod-advance-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
